define(["underscore","@bingads-webui/validation"], function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__385__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 628);
/******/ })
/************************************************************************/
/******/ ({

/***/ 385:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__385__;

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(629);


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ViewmodelSchema", {
  enumerable: true,
  get: function get() {
    return _index.ViewmodelSchema;
  }
});

var _index = __webpack_require__(630);

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewmodelSchema = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _field = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNestedList(fields, key) {
  return _underscore.default.chain(fields).filter(field => field.indexOf(`${key}/`) === 0).map(field => field.slice(key.length + 1)).value();
}

function createField(schema, i18n, fields, override) {
  return _underscore.default.chain(schema.properties).pick((value, key) => _underscore.default.find(fields, field => field === key || field.indexOf(`${key}/`) === 0)).mapObject((value, key) => {
    const prop = _underscore.default.defaults(value, {
      required: _underscore.default.contains(schema.required, key)
    });

    return value.type === 'object' ? _underscore.default.extend({
      prop
    }, createField(value.schema, i18n, getNestedList(fields, key), override)) : new _field.Field(prop, i18n, _underscore.default.result(override, key));
  }).value();
}
/**
 * Viewmodel schema, generated from schema file. It provides auto generated
 * default value, validation rules and conversions
 * @param {JsonSchema} schema - an object which contains property 'properties',
 * @param {I18n} i18n - provide callback getString to get localized string
 * @param {Array} fields - list of fields to read from schema
 * @param {Object} override - Optional override object that changes auto-generated fields
 *
 * Please notice that in schema, required can be defined on either field or schema entity level:
 * @example
 * const schema = {
 *   properties: {
 *     field1: {
 *       type: 'string',
 *       required: true, // required flag on field level
 *     },
 *   },
 *   required: ['fleid2', 'field3'], // required flag on entity level
 * }
 */


class ViewmodelSchema {
  constructor(schema, i18n, fields, override) {
    const schemaProps = createField(schema, i18n, fields, override);

    _underscore.default.extend(this, schemaProps);
  }

}

exports.ViewmodelSchema = ViewmodelSchema;

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _defaultValue = __webpack_require__(632);

var _index = __webpack_require__(633);

var _index2 = __webpack_require__(639);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Viewmodel schema field
 * @param {Object} prop - schema property bag
 * @param {I18n} i18n - provide callback getString to get localized string
 * @param {Object} override - Optional override object that changes auto-generated fields
 */
class Field {
  constructor(prop, i18n, override) {
    this.prop = prop;
    this.i18n = i18n;
    this.override = override;
  }
  /**
   * Get default value generated from schema
   * @returns {Object} - default value
   */


  get default() {
    let defaultValue = (0, _defaultValue.getDefaultValue)(this.prop);

    if (this.override && _underscore.default.isFunction(this.override.default)) {
      defaultValue = this.override.default(defaultValue);
    }

    return defaultValue;
  }
  /**
   * Get validation rules generated from schema
   * @returns {Object} - validation rules
   */


  get validation() {
    let validation = (0, _index.createValidation)(this.prop, this.i18n);

    if (this.override && _underscore.default.isFunction(this.override.validation)) {
      validation = this.override.validation(validation);
    }

    return validation;
  }
  /**
   * Get conversions generated from schema
   * @returns {Object} - object that handles fromModel and toModel conversion
   */


  get conversion() {
    let conversion = (0, _index2.createConversion)(this.prop, this.i18n);

    if (this.override && _underscore.default.isFunction(this.override.conversion)) {
      conversion = this.override.conversion(conversion);
    }

    return conversion;
  }

}

exports.Field = Field;

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultValue = getDefaultValue;

var _underscore = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultValues = {
  integer: 0,
  number: undefined,
  string: '',
  boolean: false,
  object: {},
  array: [],
  datetime: {}
};
/**
 * get default value for property
 * @param {Object} prop - property define, it's from schema
 * @returns {any} - return default value for different type
 */

function getDefaultValue(prop) {
  if (_underscore.default.has(prop, 'default')) {
    return prop.default;
  }

  if (!_underscore.default.isEmpty(prop.enum)) {
    return prop.nullable ? null : _underscore.default.first(prop.enum);
  }

  return _underscore.default.clone(defaultValues[prop.type]);
}

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createValidation = createValidation;

var _validation = __webpack_require__(385);

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _baseFactory = __webpack_require__(634);

var _enumFactory = __webpack_require__(635);

var _numberFactory = __webpack_require__(636);

var _stringFactory = __webpack_require__(637);

var _arrayFactory = __webpack_require__(638);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Find validation rules factory by field type
 * @param {Object} prop - Schema field properties
 * @param {I18n} i18n - i18n for localization
 * @returns {Object} - returns factory for validation rules
 */
function getRuleFactoryByType(prop, i18n) {
  switch (prop.type) {
    case 'integer':
      return new _numberFactory.NumberFactory({
        prop: _underscore.default.defaults({
          decimalLength: 0
        }, prop),
        i18n
      });

    case 'number':
      return new _numberFactory.NumberFactory({
        prop: _underscore.default.defaults({
          decimalLength: 2
        }, prop),
        i18n
      });

    case 'boolean':
      return new _enumFactory.EnumFactory({
        prop: {
          enum: [true, false]
        },
        i18n
      });

    case 'string':
      return prop.enum ? new _enumFactory.EnumFactory({
        prop,
        i18n
      }) : new _stringFactory.StringFactory({
        prop,
        i18n
      });

    case 'array':
      return new _arrayFactory.ArrayFactory({
        prop,
        i18n
      });

    default:
      return new _baseFactory.BaseFactory({
        prop,
        i18n
      });
  }
}
/**
 * Create validation rules by field type
 * @param {Object} prop - Schema field properties
 * @param {I18n} i18n - i18n for localization
 * @returns {Object} - returns validation rules
 */


function createValidation(prop, i18n) {
  const factory = getRuleFactoryByType(prop, i18n);
  const rules = factory.create();

  if (prop.required) {
    // allowspace means whether value with pure spaces is treated as valid
    const allowSpace = _underscore.default.result(prop, 'allowSpace', false);

    rules.required = _validation.Validation.required(allowSpace, i18n);
  }

  return rules;
}

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseFactory = void 0;

/**
 * Base factory for validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
class BaseFactory {
  constructor(options) {
    this.prop = options.prop;
    this.i18n = options.i18n;
  }
  /**
   * Base method to create rules set
   * @returns {Object} - empty rules set
   */


  create() {
    return {};
  }

}

exports.BaseFactory = BaseFactory;

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnumFactory = void 0;

var _validation = __webpack_require__(385);

var _baseFactory = __webpack_require__(634);

/**
 * Factory for enum validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
class EnumFactory extends _baseFactory.BaseFactory {
  /**
   * Create enum rules set from schema property
   * @returns {Object} - enum validation rules set
   */
  create() {
    return {
      enum: _validation.Validation.enum(this.prop.enum, this.i18n)
    };
  }

}

exports.EnumFactory = EnumFactory;

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFactory = void 0;

var _validation = __webpack_require__(385);

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _baseFactory = __webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Factory for number validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
class NumberFactory extends _baseFactory.BaseFactory {
  /**
   * Create number rules set from schema property
   * @returns {Object} - number validation rules set
   */
  create() {
    const rules = {
      type: _validation.Validation.number.type(this.i18n).set({
        nullable: this.prop.nullable
      }),
      decimalLength: _validation.Validation.number.size(undefined, this.prop.decimalLength, this.i18n).set({
        nullable: this.prop.nullable
      })
    };

    if (_underscore.default.isFinite(this.prop.maximum) || _underscore.default.isFinite(this.prop.minimum) || this.prop.isPercentValue) {
      const minimum = _underscore.default.isFinite(this.prop.minimum) ? this.prop.minimum : this.prop.isPercentValue && 0;
      const maximum = _underscore.default.isFinite(this.prop.maximum) ? this.prop.maximum : this.prop.isPercentValue && 100;
      rules.range = _validation.Validation.number.range(minimum, maximum, this.i18n).set({
        nullable: this.prop.nullable
      });
    }

    return rules;
  }

}

exports.NumberFactory = NumberFactory;

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringFactory = void 0;

var _validation = __webpack_require__(385);

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _baseFactory = __webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Factory for string validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
class StringFactory extends _baseFactory.BaseFactory {
  /**
   * Create string rules set from schema property
   * @returns {Object} - string validation rules set
   */
  create() {
    const rules = {};

    if (_underscore.default.isFinite(this.prop.maxLength)) {
      rules.maxLength = _validation.Validation.string.size(this.prop.maxLength, this.prop.distinguishCJK, this.i18n);
    }

    if (_underscore.default.isFinite(this.prop.minLength)) {
      rules.minLength = _validation.Validation.string.minSize(this.prop.minLength, this.prop.distinguishCJK, this.i18n);
    }

    if (this.prop.pattern) {
      rules.pattern = _validation.Validation.string.pattern(this.prop.pattern, this.i18n);
    }

    if (this.prop.checkXss) {
      rules.checkXss = _validation.Validation.string.xss(this.i18n);
    } // apply nullable prop


    _underscore.default.each(rules, rule => {
      rule.set({
        nullable: this.prop.nullable !== false
      });
    });

    return rules;
  }

}

exports.StringFactory = StringFactory;

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayFactory = void 0;

var _validation = __webpack_require__(385);

var _baseFactory = __webpack_require__(634);

/**
 * Factory for array validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
class ArrayFactory extends _baseFactory.BaseFactory {
  /**
   * Create array rules set from schema property
   * @returns {Object} - array validation rules set
   */
  create() {
    const rules = {};

    if (this.prop.minItems || this.prop.maxItems) {
      rules.size = _validation.Validation.array.size(this.prop.minItems, this.prop.maxItems, this.i18n);
    }

    if (this.prop.uniqueItems) {
      rules.unique = _validation.Validation.array.unique(this.i18n);
    }

    return rules;
  }

}

exports.ArrayFactory = ArrayFactory;

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConversion = createConversion;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _baseFactory = __webpack_require__(640);

var _numberFactory = __webpack_require__(641);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Find conversion factory by field type
 * @param {Object} prop - Schema field properties
 * @param {I18n} i18n - i18n for localization
 * @returns {Object} - returns factory for conversion object
 */
function getConvertorFactoryByType(prop, i18n) {
  switch (prop.type) {
    case 'integer':
      return new _numberFactory.NumberFactory({
        prop: _underscore.default.defaults({
          decimalLength: 0
        }, prop),
        i18n
      });

    case 'number':
      return new _numberFactory.NumberFactory({
        prop: _underscore.default.defaults({
          decimalLength: 2
        }, prop),
        i18n
      });

    default:
      return new _baseFactory.BaseFactory({
        prop,
        i18n
      });
  }
}
/**
 * Create conversion object by field type
 * @param {Object} prop - Schema field properties
 * @param {I18n} i18n - i18n for localization
 * @returns {Object} - returns conversion object
 */


function createConversion(prop, i18n) {
  const factory = getConvertorFactoryByType(prop, i18n);
  return factory.create();
}

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseFactory = void 0;

/**
 * Base factory for conversion object
 * @param {Object} options - input for schema property bag and i18n
 */
class BaseFactory {
  constructor(options) {
    this.prop = options.prop;
    this.i18n = options.i18n;
  }
  /**
   * Base method to create conversion object
   * @returns {Object} - pass-through conversion object
   */


  create() {
    const passThrough = value => value;

    return {
      fromModel: passThrough,
      toModel: passThrough
    };
  }

}

exports.BaseFactory = BaseFactory;

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFactory = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _baseFactory = __webpack_require__(640);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Factory for number conversion object
 * @param {Object} options - input for schema property bag and i18n
 */
class NumberFactory extends _baseFactory.BaseFactory {
  numberToString(num, numberOfDigits, i18n) {
    if (!_underscore.default.isNumber(num)) {
      return num;
    }

    return i18n.formatDecimal(num, {
      minimumFractionDigits: numberOfDigits,
      maximumFractionDigits: numberOfDigits
    });
  }

  stringToNumber(localizedString, i18n) {
    if (_underscore.default.isEmpty(localizedString)) {
      // Convert to null if string is null or empty. Leave it to required validator to raise error.
      return null;
    }

    if (!i18n.isValidDecimal(localizedString)) {
      // Do not convert if it is not decimal. Leave it to validator raise type error.
      return localizedString;
    }

    return i18n.parseDecimal(localizedString);
  }
  /**
   * Create number conversion object
   * @returns {Object} - conversion object that convers number to and from string
   */


  create() {
    return {
      fromModel: value => this.numberToString(value, this.prop.decimalLength, this.i18n),
      toModel: value => this.stringToNumber(value, this.i18n)
    };
  }

}

exports.NumberFactory = NumberFactory;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ })});;
